import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const Profile = lazy(
  () => import(/* webpackChunkName: "Profile" */ 'modules/Profile/pages/Profile')
)

const ProfileRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route path={routes.root} component={Profile} />
      <Redirect path='*' to={routes.progress} />
    </Switch>
  </Suspense>
)

export default ProfileRouting
